import { Icon, IconProps } from "./Icon";

export function IconStarFilled(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="m9.54,9.62l0.22,-0.71m2.24,-8.91a0.67,0.67 0 0 0 -0.65,0.5l-2.52,8.12l-8.14,0a0.73,0.73 0 0 0 -0.41,1.3l6.59,5l-2.51,8.13a0.71,0.71 0 0 0 0.64,0.95a0.63,0.63 0 0 0 0.4,-0.14l6.59,-5l6.59,5a0.63,0.63 0 0 0 0.42,0.14a0.71,0.71 0 0 0 0.65,-0.95l-2.51,-8.11l6.59,-5a0.73,0.73 0 0 0 -0.41,-1.3l-8.15,0l-2.52,-8.14a0.67,0.67 0 0 0 -0.65,-0.5z" />
    </Icon>
  );
}
